<template>
  <div
    class="border rounded p-5"
    v-for="(item, index) in items"
    :class="{ 'bg-red-50 ': item.cancel_flag === 'c' }"
    :key="item.pr_item_id"
  >
    <div class="flex flex-row justify-between">
      <div class="font-bold text-xl mb-4">ลำดับที่ {{ index + 1 }}.</div>
      <div>
        <div>
          <a
            href="javascript:;"
            class="btn btn-danger mt-2"
            data-toggle="modal"
            data-target="#cancel-pr-item-modal-preview"
            @click="setCancelPOItem(item.po_item_id)"
            v-if="item.cancel_flag !== 'c' && page == 'detail'"
          >
            <XCircleIcon class="w-4 h-4 mr-2 hidden md:block" />
            ยกเลิก
          </a>
        </div>
      </div>
    </div>
    <div
      class="grid grid-cols-1 lg:grid-cols-3 space-y-2 lg:space-y-0 lg:gap-4"
    >
      <!-- col-1 -->
      <div class="col-span-2">
        <div class="text-lg font-bold">รายละเอียดสินค้า</div>

        <div class="mb-2">
          <div class="font-bold">รายการสินค้า:</div>
          <!-- <div>{{ item.item_name }}</div> -->
          <div
            v-html="
              item.item_name ? item.item_name.replaceAll('\n', '<br>') : ''
            "
          ></div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <div>
            <div class="flex justify-between">
              <div class="font-bold">หมวดหมู่สินค้า:</div>
              <div>{{ item.item_category }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">รหัสชนิดสินค้า:</div>
              <div>{{ item.item_code }}</div>
            </div>

            <div class="flex justify-between">
              <div class="font-bold">หน่วยนับ:</div>
              <div>{{ item.uom }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">วันที่ต้องการใช้:</div>
              <div>{{ item.use_date }}</div>
            </div>
            <div class="">
              <div class="font-bold">สถานที่รับสินค้า:</div>
              <div>{{ item.pickup_loc }}</div>
            </div>
          </div>
          <!-- col-2 -->
          <div>
            <div class="flex justify-between">
              <div class="font-bold">ราคาต่อหน่วย:</div>
              <div>{{ numberFormat(item.unit_price) }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">จำนวนหน่วย:</div>
              <div>{{ numberFormat(item.qty) }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">ราคาก่อนภาษี:</div>
              <div>{{ numberFormat(item.amount) }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">ภาษีมูลค่าเพิ่ม {{ item.vat_rate }}%:</div>
              <div>{{ numberFormat(item.vat) }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">Actual Cost:</div>
              <div>{{ numberFormat(item.actual_cost) }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- col-3 -->
      <div>
        <div class="text-lg font-bold">รายละเอียดงบประมาณ</div>
        <!-- ปีงบประมาณ -->
        <div class="flex justify-between">
          <div class="font-bold">
            ปีงบประมาณ:
          </div>
          <div>{{ item.budget_year }}</div>
        </div>
        <!-- ชนิดงบประมาณ -->
        <div class="flex justify-between">
          <div class="font-bold">
            ชนิดงบประมาณ:
          </div>
          <div>
            {{ item.budget_subledger ? 'งบประมาณโครงการ' : 'งบประมาณหน่วยงาน' }}
          </div>
        </div>
        <!-- ใช้งบประมาณของหน่วยงาน -->
        <div class="">
          <div class="font-bold">
            ใช้งบประมาณของหน่วยงาน:
          </div>
          <div>
            {{ item.budget_bu_name }}
          </div>
        </div>
        <!-- รหัสงบประมาณ -->
        <div class="flex justify-between">
          <div class="font-bold">
            รหัส BU:
          </div>
          <div>
            {{ item.budget_bu_code }}
          </div>
        </div>
        <!-- account code -->
        <div class="flex justify-between">
          <div class="font-bold">
            Account Code:
          </div>
          <div>
            {{ item.budget_code }}
          </div>
        </div>
        <!-- account name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subsidiary:
          </div>
          <div>
            {{ item.budget_subsidiary }}
          </div>
        </div>
        <!-- account name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Account Name:
          </div>
          <div>
            {{ item.budget_name }}
          </div>
        </div>
        <!-- Subledger -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subledger:
          </div>
          <div>
            {{ item.budget_subledger }}
          </div>
        </div>
        <!-- Subledger Name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subledger Name:
          </div>
          <div>
            {{ item.budget_subledger_name }}
          </div>
        </div>
        <!-- รายละเอียดภาษี -->
        <div class="mt-2 md:mt-4">
          <div class="text-lg font-bold">รายละเอียดภาษี</div>
          <!-- Tax Rate: -->
          <!-- <div class="flex justify-between">
            <div class="font-bold">Tax Rate:</div>
            <div>
              {{ getTaxRate(item.tax_rate) }}
            </div>
          </div>
          <div class="flex justify-between">
            <div class="font-bold">GL Offset:</div>
            <div>
              {{ item.gl_offset ? item.gl_offset : 'ไม่ระบุ' }}
            </div>
          </div>
          <div class="flex justify-between">
            <div class="font-bold">Cat Code:</div>
            <div>{{ getCatCode(item.cat_code) }}</div>
          </div> -->
          <BcVatLabel
            v-if="isBc"
            :key="index"
            :bcVatProd="item.bc_vat_prod"
            :bcWhtBus="item.bc_wht_bus"
            :bcWhtProd="item.bc_wht_prod"
            :bcElim="item.bc_elim"
          />
        </div>
      </div>
    </div>
    <div v-if="item.cancel_flag === 'c'">
      <div class="text-theme-6">
        <b>เหตุผลการยกเลิก</b> : {{ item.history }}
      </div>
    </div>
  </div>
  <!-- BEGIN: Modal Content -->
  <div
    id="cancel-pr-item-modal-preview"
    class="modal"
    tabindex="-1"
    data-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="p-5 text-center">
            <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
            <div class="text-3xl mt-5">คุณแน่ใจ</div>
            <div class="text-gray-600 mt-2">
              ต้องการลบรายการนี้ ใช่ หรือ ไม่?
            </div>
            <div class="mt-4 text-left">
              <label for="" class="form-label text-lg"
                >เหตุผลในการยกเลิก:</label
              >
              <textarea
                name=""
                class="form-control"
                rows="5"
                v-model="currentReason"
                placeholder="เพิ่มเติม..."
              ></textarea>
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
              @click="cancelPOItem()"
            >
              ไม่
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-danger w-24"
              @click="confirmCancelPOItem()"
            >
              ใช่
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, ref } from 'vue'
import { useStore } from '@/store'
import helpers from '@/helpers'
import BcVatLabel from './BcVatLabel.vue'

export default defineComponent({
  name: 'table-item-po',
  components: {
    BcVatLabel
  },
  props: {
    items: Array,
    page: {
      type: String,
      default: () => 'detail'
    }
  },
  emits: ['updateCancel'],
  setup(props, context) {
    const store = useStore()
    // const taxRateOptions = computed(() => store.state.global.taxRate)
    // const catCodeOptions = computed(() => store.state.global.catCode)
    const isBc = computed(() => process.env.VUE_APP_ACCOUNT_MODULE == 'BC365')

    // const getTaxRate = taxRate => {
    //   if (taxRate) {
    //     const rate = taxRateOptions.value.find(
    //       item => item.tax_code === taxRate
    //     )
    //     if (rate) {
    //       return `${rate.tax_code} - ${rate.tax_name}`
    //     } else {
    //       return 'ข้อมูลไม่ตรงกัน'
    //     }
    //   } else {
    //     return 'ไม่ระบุ'
    //   }
    // }

    // const getCatCode = catCode => {
    //   if (catCode !== null) {
    //     const code = catCodeOptions.value.find(
    //       item => item.cat_code === catCode
    //     )
    //     if (code) {
    //       return `${code.cat_code} - ${code.cat_name}`
    //     } else {
    //       return 'ข้อมูลไม่ตรงกัน'
    //     }
    //   } else {
    //     return 'ไม่ระบุ'
    //   }
    // }

    const { numberFormat } = helpers

    const currentItemId = ref(null)
    const currentReason = ref(null)
    const setCancelPOItem = id => {
      currentItemId.value = id
      currentReason.value = null
    }

    const cancelPOItem = () => {
      currentItemId.value = null
      currentReason.value = null
    }

    const confirmCancelPOItem = () => {
      context.emit('updateCancel', {
        itemId: currentItemId.value,
        reason: currentReason.value
      })
      currentItemId.value = null
      currentReason.value = null
      // alert.success()
    }

    onMounted(async () => {
      store.dispatch('global/loadTaxRate')
      store.dispatch('global/loadCatCode')
    })
    return {
      props,
      numberFormat,
      // getTaxRate,
      // getCatCode,
      setCancelPOItem,
      cancelPOItem,
      confirmCancelPOItem,
      currentReason,
      isBc
    }
  }
})
</script>
